<template>
  <a-card
    title="首页快捷入口"
    :bordered="false"
    :bodyStyle="{ padding: '20px' }"
    :headStyle="{ borderBottom: '0px', fontSize: '18px', paddingLeft: '20px' }"
  >
    <a-row style="margin-bottom: 10px;">
      <a-col :span="24" style="text-align: right;"
      >
        <a-button type="primary" @click="handleContent(0)">添加新内容</a-button>
      </a-col
      >
    </a-row>

    <custom-paging-dragging-list
      ref="table"
      rowKey="iconId"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="sortIdSlots" slot-scope="data">
        {{ data.index + 1 }}
      </div>

      <div class="image-table" slot="imageSlots" slot-scope="data">
        <CustomImage :imageUrl="data.record.iconImg"></CustomImage>
      </div>
      <span slot="iconTypeSlots" slot-scope="data">{{ data.record.iconType | getIconContentName }}</span>
      <span slot="statusSlots" slot-scope="data">{{ data.record.iconStatus | getIconStatusName }}</span>
      <div slot="action" slot-scope="data">
        <a @click="editData(data.record)">编辑</a>
        <span>
          <a-divider type="vertical"/>
          <a v-if="data.record.iconStatus == 0" @click="updateIconList(data.record.iconId, 1)">显示</a>
          <a v-else @click="updateIconList(data.record.iconId, 0)">隐藏</a>
        </span>
        <span v-if="data.record.iconType != 0">
          <a-divider type="vertical"/>
          <a-popconfirm title="是否要删除当前动态？" @confirm="deleteEvent(data.record.iconId)">
            <a-icon slot="icon" type="close-circle" style="color: red;"/>
            <a>删除</a>
          </a-popconfirm>
        </span>
        <span
          v-if="
            data.record.iconType == 0 &&
            (data.record.iconProType == 1 || data.record.iconProType == 2 || data.record.iconProType == 5)
          "
        >
          <a-divider type="vertical"/>
          <a @click="goChannelSet(data.record.iconProType)">频道设置</a>
        </span>
      </div>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>
import EditableCell from '../component/editableCell'
import SkipOtherHelper from '../../../utils/helper/SkipOtherHelper'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'HomeInlet',
  components: {
    EditableCell,
    CustomPagingDraggingList
  },
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getIconListPromise(params),
      columns: [
        {
          title: '排序',
          dataIndex: 'iconSort',
          scopedSlots: { customRender: 'sortIdSlots' },
          width: '120px'
        },
        {
          title: '图标',
          dataIndex: 'iconImg',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '标题',
          dataIndex: 'iconName'
        },
        {
          title: '内容类型',
          dataIndex: 'iconType',
          scopedSlots: { customRender: 'iconTypeSlots' }
        },
        {
          title: '投放时间',
          dataIndex: 'iconUpdateTime'
        },
        {
          title: '状态',
          dataIndex: 'iconStatus',
          scopedSlots: { customRender: 'statusSlots' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    // 获取表格数据接口
    getIconListPromise(params) {
      this.getLogUtils().logWithTag('==getIconListPromise==', params)
      return this.getHttpServices().getUserService().post('homepage/icon/get/iconList', params)
    },
    // 删除
    deleteEvent(id) {
      this.getLogUtils().logWithTag('deleteEvent', id)
      let params = new Object()
      params.iconId = id
      this.getHttpServices().getUserService().post('homepage/icon/del/iconDetail', params)
        .then(res => {
          this.getLogUtils().logWithTag('==deleteEvent==', res)
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toDetail(item) {

    },
    // 拖拽排序功能
    onDraggable(params) {
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      let iconList = new Array
      iconList = params.dataList.map((item) => {
        return item.iconId
      })
      this.getHttpServices().getUserService().post('homepage/icon/orderBy/iconList', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: iconList
      }).then(res => {
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 显示隐藏操作
    updateIconList(iconId, iconStatus) {
      this.getHttpServices().getUserService().post('homepage/icon/update/iconStatus', {
        iconId: iconId,
        iconStatus: iconStatus
      }).then(res => {
        this.getLogUtils().logWithTag('==updateIconList==', res)
        this.$message.success('操作成功')
        this.$refs.table.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 排序
    onCellChange(iconId, value) {
      this.getLogUtils().logWithTag('onCellChange', iconId, value)
      let params = new Object()
      params.iconId = iconId
      params.iconSort = value
      this.getHttpServices().getUserService().post('homepage/icon/update/iconSort', params)
        .then(res => {
          this.getLogUtils().logWithTag('==onCellChange==', res)
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 新增内容
    handleContent(iconId) {
      this.$router.push({
        name: 'AddInletContent',
        query: {
          iconId: iconId
        }
      })
    },
    // 商品类目编辑
    editData(data) {
      this.getLogUtils().logWithTag('editData', data)
      if (data.iconType == 0) {
        this.$router.push({
          name: 'EditInletContent',
          query: {
            iconId: data.iconId,
            iconProType: data.iconProType
          }
        })
      } else {
        this.handleContent(data.iconId)
      }
    },
    // 频道设置
    goChannelSet(catalogId) {
      if (catalogId == 5) {
        this.$router.push({
          name: 'DepartmentSetting',
          query: {
            catalogId: catalogId
          }
        })
      } else {
        this.$router.push({
          name: 'ChannelSetting',
          query: {
            catalogId: catalogId
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.image-table {
  width: 40px;
  height: 40px;

  img {
    width: 40px;
    height: 40px;
  }
}
</style>